import React from "react";
import "./WeekIntroBlock.css";

export default function WeekIntroBlock({ weekIntro }) {
  if (!weekIntro) return null;

  return (
    <div className="week-intro">
      <div className="week-intro-section">
        <strong>Skills you will build:</strong>
        <ul>
          {(weekIntro.skills || []).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="week-intro-section">
        <strong>What this week teaches:</strong>
        <p>{weekIntro.what_this_week_teaches}</p>
      </div>

      <div className="week-intro-section">
        <strong>By the end of this week:</strong>
        <ul>
          {(weekIntro.by_the_end || []).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="week-intro-focus">{weekIntro.focus_message}</div>
    </div>
  );
}
